import { useEffect, useState } from "react"
import ReactApexChart from "react-apexcharts";
import { getUnitSellingChart } from "../../../services/unit/unit_selling_service";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import CustomSpinner from "../../../components/customs/spinner";

const generateRandomData = (length, min, max) => {
    return Array.from({ length }, () => Math.floor(Math.random() * (max - min + 1)) + min);
};

const SellingChart = () => {

    const [accessToken, setAccessToken] = useState(null)
    const [userRole, setUserRole] = useState(null)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)


    const [year, setYear] = useState(new Date().getFullYear())
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear())

    const generateYears = () => {
        const startYear = currentYear - 15
        const endYear = currentYear + 15

        return Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
    }


    const [data, setData] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
    const fetchData = async (accessToken, year) => {
        setLoading(true)
        try {
            const response = await getUnitSellingChart(accessToken, year)
            if (response.status === 200) {
                setData(response.data.data)
            }
        } catch (error) {
            console.log("__")
        }
        setLoading(false)
    }

    const [dataChart, setDataChart] = useState({

        series: [{
            name: "Penjualan Unit Rumah / Ruko",
            data: data
        }],

        options: {
            chart: {
                type: 'area',
                height: 350,
            },
            dataLabels: {
                enabled: true
            },
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            title: {
                text: 'Penjualan Unit Rumah / Ruko',
                align: 'left'
            },
            // subtitle: {
            //     text: `Tahun ${year}`,
            //     align: 'left'
            // },
            stroke: {
                curve: 'smooth'
            },
            yaxis: {
                opposite: true
            },
            legend: {
                horizontalAlign: 'left'
            }
        }
    })

    useEffect(() => {
        const accessToken = localStorage.getItem('access_token-terra_app')
        const userRole = localStorage.getItem('user_role-terra_app')
        if (!accessToken || !userRole) {
            navigate('/login')
        } else {
            setAccessToken(accessToken)
            setUserRole(userRole)
            fetchData(accessToken, year)
        }
    }, [])

    useEffect(() => {
        setDataChart((prev) => ({
            ...prev,
            series: [{
                name: "Penjualan Unit Rumah / Ruko",
                data: data
            }]
        }));
    }, [data]);

    useEffect(() => {
        fetchData(accessToken, year)
    }, [year]);

    return (
        <div className="px-5">
            <label className="space-y-1">
                <div className="flex items-center gap-3">
                    <span className="pl-3 font-semibold">Pilih Tahun (Grafik)</span>
                    {loading && <CustomSpinner />}
                </div>
                <div className="relative flex items-center justify-center">
                    <select
                        value={year}
                        onChange={(e) => {
                            const newValue = e.target.value
                            setYear(newValue)
                            setCurrentYear(newValue ? Number(newValue) : 2024)
                        }}
                        className="w-full rounded-full px-3 py-2 md:py-1 appearance-none border-2"
                    >
                        <option value="" key="">semua</option>
                        {generateYears().map((item) => (
                            <option value={item}>{item}</option>
                        ))}
                    </select>
                    <FontAwesomeIcon icon={faChevronDown} className="absolute right-[8px] z-10 text-black" />
                </div>
            </label>
            <div id="chart">
                <ReactApexChart
                    options={dataChart.options}
                    series={dataChart.series}
                    type="area"
                    height={350}
                />
            </div>
            <div id="html-dist"></div>
        </div>
    )
}

export default SellingChart